import { useMapAttributeName, useMapAttributeType } from "../../hooks/use-map-attribute";
import { useDateRange } from "../../hooks/use-date-range";
import { RegionInfo, RegionInfoFilter } from "../../models/region";
import { useEffect, useState } from "react";
import { useStore } from "react-admin";
import { Box, Typography } from "@mui/material";
import { RegionYearBuiltChart } from "./region-year-built-chart";
import { RegionMapAttributeChart } from "./region-map-attribute-chart";
import { useDataType } from "../../hooks/use-data-type";
import { RegionYearBuiltChartPie } from "./region-year-built-chart-pie";
import { RegionSchoolsChart } from "./region-schools-chart";

export type RegionYearBuilt = {
  id: number;
  yearBuilt: number;
  yearBuiltCount: number;
}

export const RegionInfoPanel = ({ }: {}) => {

  const [filter, setFilter] = useState<RegionInfoFilter>({
    regionId: '',
    regionType: undefined,
    from: '',
    to: '',
    type: null
  });

  const [region] = useStore<RegionInfo>('region.active', undefined);
  const [from, to] = useDateRange();
  const [mapAttributeType] = useMapAttributeType();
  const [mapAttributeName] = useMapAttributeName();
  const [_, getDataTypeString] = useDataType();

  useEffect(() => {
    console.log('Selected region:', region);
    // Fetch additional region data if needed
    if (!region) {
      resetFilter();
      return;
    }

    // Set filter for charts
    setFilter({
      regionId: region.id,
      regionType: region.type,
      from: from,
      to: to,
      type: mapAttributeType
    });
  }, [region, from, to, mapAttributeType]);

  const resetFilter = () => {
    setFilter({
      regionId: '',
      regionType: undefined,
      from: '',
      to: '',
      type: null
    });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='subtitle1' sx={{}}>{('Region: ' + (region?.label ?? ''))}</Typography>
        <Box>
          <Typography
            variant='body2'
            style={{ display: 'inline-block' }}
          >
            {mapAttributeName + ':'}
          </Typography>
          <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
            {getDataTypeString(region?.data?.dataMean)}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant='body2'
            style={{ display: 'inline-block' }}
            sx={{ marginBottom: 0 }}
          >
            {'Samples amount:'}
          </Typography>
          <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
            {region?.data?.dataCount}
          </Typography>
        </Box>
      </Box>


      <RegionMapAttributeChart filter={filter} />
      <RegionYearBuiltChart filter={filter} />
      {/* <RegionYearBuiltChartPie filter={filter} /> */}
      <RegionSchoolsChart filter={filter} />
    </Box>
  )
};

